import store from '@/store';
import router from '@/router';

import normalize from '../normalizer';

export default function error (error) {
  const data = null;
  const ok = false;

  if (!error.response) {
    return normalize({
      ok,
      status: 499,
      errorMessage: 'Request cancelled',
      data
    });
  }

  if (error.response.status === 401) {
    store.dispatch('auth/logout');

    return normalize({
      ok,
      status: error.response.status,
      errorMessage: 'Invalid credentials',
      data
    });
  } else if (error.response.status === 403) {
    router.replace({ name: 'Unauthorized' });

    return normalize({
      ok,
      status: error.response.status,
      errorMessage: 'Invalid permissions',
      data
    });
  }

  return normalize({
    ok,
    status: error.response.status,
    errorMessage: error.response.Message || 'An error occurred while processing the request',
    data
  });
}
